import Card from 'Components/Atoms/Card/Card';
import CardHeader from 'Components/Atoms/Card/CardHeader/CardHeader';
import Container from 'Components/Atoms/Container/Container';
import Loader from 'Components/Atoms/Loader/Loader';
import Text from 'Components/Atoms/Text/Text';
import Title from 'Components/Atoms/Title/Title';
import OptionList from 'Components/Organisms/OptionList/OptionList';
import React, { Suspense } from 'react';
import { Tab } from 'Services/Tab/TabContext';
import TitleGroup from '../TitleGroup/TitleGroup';

const Contact = React.lazy(() => import('Components/Organisms/Contact/Contact'));
const CooperationConditions = React.lazy(() => import('Components/Organisms/CooperationConditions/CooperationConditions'));
const Files = React.lazy(() => import('Components/Organisms/Files/Files'));
const Notes = React.lazy(() => import('Components/Organisms/Notes/Notes'));
const TalentProposal = React.lazy(() => import('Components/Organisms/TalentProposal/TalentProposal'));
const Mails = React.lazy(() => import('Components/Organisms/Modules/Mails/Mails/Mails'));

const ModulesTab = ({
    activeTab,
    id, entity_id
}: Props) => {
    return <Suspense fallback={<Loader />}>
        <Container size='medium'>
            { activeTab === Tab.NOTES && <Notes id={id} /> }
            { activeTab === Tab.TALENT_PROPOSAL && <TalentProposal entity_id={entity_id} record_id={id}/> }
            { activeTab === Tab.COOPERATION_CONDITION && <CooperationConditions /> }
            { activeTab === Tab.FILES && <Files id={id} /> }
            {
                activeTab === Tab.CONTACT &&
                <Card>
                    <CardHeader>
                        <TitleGroup gap='small'>
                            <Title weight='semibold'>Contactgegevens</Title>
                            <Text color='secondary'>Bekijk en/of maak nieuwe contactgegevens aan</Text>
                        </TitleGroup>
                    </CardHeader>
                    <Container padding='vertical'>
                        <Contact
                            id={id}
                            entity_id={entity_id}
                        />
                    </Container>
                </Card>
            }
            {
                activeTab === Tab.MAILS &&
                <Card>
                    <CardHeader>
                        <TitleGroup gap='small'>
                            <Title weight='semibold'>Mails</Title>
                            <Text color='secondary'>Bekijk gerelateerde inkomende mails</Text>
                        </TitleGroup>
                    </CardHeader>
                    <Container padding='vertical'>
                        <Mails
                            entity_record_id={id}
                        />
                    </Container>
                </Card>
            }
        </Container>
        {
            activeTab === Tab.OPTION_LISTS &&
            <Card>
                <CardHeader>
                    <TitleGroup gap='small'>
                        <Title weight='semibold'>Optielijsten</Title>
                        <Text color='secondary'>Bekijk optielijsten</Text>
                    </TitleGroup>
                </CardHeader>
                <Container padding='vertical'>
                    <OptionList entity_record_id={id} />
                </Container>
            </Card>
        }
    </Suspense>;
}

interface Props {
    activeTab: Tab
    id: any
    entity_id: any
}

export default ModulesTab;